/* istanbul ignore file */
export default [
  {
    path: '/activities/overview',
    name: 'activitiesOverview',
    component: () => import('../views/Overview'),
    meta: {
      auth: true
    }
  },
  {
    path: '/activities/overview/funnel',
    name: 'activitiesOverviewFunnel',
    component: () => import('../views/OverviewFunnel'),
    meta: {
      auth: true
    }
  },
  {
    path: '/activities/overview/sunburst',
    name: 'activitiesOverviewSunburst',
    component: () => import('../views/OverviewSunburst'),
    meta: {
      auth: true
    }
  },
  {
    path: '/activities/overview/sankey',
    name: 'activitiesOverviewSankey',
    component: () => import('../views/OverviewSankey'),
    meta: {
      auth: true
    }
  },
  {
    path: '/activities/techcheck',
    name: 'techCheck',
    component: () => import('../views/TechCheck'),
    meta: {
      auth: true
    }
  },
  {
    path: '/activities/monitor',
    name: 'monitor',
    component: () => import('../views/Monitor'),
    meta: {
      auth: true
    }
  }
]
